import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FooterContent } from './FooterContent';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FileUploadedFooter_NotificationGroupAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupAccessRequestApproved' };

export type FileUploadedFooter_NotificationGroupAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupAccessRequestDenied' };

export type FileUploadedFooter_NotificationGroupAccessRequestSubmitted_Fragment = { __typename?: 'NotificationGroupAccessRequestSubmitted' };

export type FileUploadedFooter_NotificationGroupAssetAssignedToYou_Fragment = { __typename?: 'NotificationGroupAssetAssignedToYou' };

export type FileUploadedFooter_NotificationGroupAssetStatusChanged_Fragment = { __typename?: 'NotificationGroupAssetStatusChanged' };

export type FileUploadedFooter_NotificationGroupCommentCreated_Fragment = { __typename?: 'NotificationGroupCommentCreated' };

export type FileUploadedFooter_NotificationGroupCommentCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupCommentCreatedShareAccess' };

export type FileUploadedFooter_NotificationGroupFileUploaded_Fragment = { __typename?: 'NotificationGroupFileUploaded', content: { __typename?: 'NotificationGroupContent', layout: { __typename?: 'NotificationLayout', footer?: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName' } | { __typename?: 'NotificationLayoutItemSection', content: Array<{ __typename?: 'NotificationLayoutItemAssetName' } | { __typename?: 'NotificationLayoutItemChip' } | { __typename?: 'NotificationLayoutItemProjectName', content: string } | { __typename?: 'NotificationLayoutItemSection' } | { __typename?: 'NotificationLayoutItemShareName', content: string } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp', content: string } | { __typename?: 'NotificationLayoutItemUserName' }> } | { __typename?: 'NotificationLayoutItemShareName' } | { __typename?: 'NotificationLayoutItemText' } | { __typename?: 'NotificationLayoutItemTimestamp' } | { __typename?: 'NotificationLayoutItemUserName' }> | null } } };

export type FileUploadedFooter_NotificationGroupReplyCreated_Fragment = { __typename?: 'NotificationGroupReplyCreated' };

export type FileUploadedFooter_NotificationGroupReplyCreatedShareAccess_Fragment = { __typename?: 'NotificationGroupReplyCreatedShareAccess' };

export type FileUploadedFooter_NotificationGroupRequesterAccessRequestApproved_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestApproved' };

export type FileUploadedFooter_NotificationGroupRequesterAccessRequestDenied_Fragment = { __typename?: 'NotificationGroupRequesterAccessRequestDenied' };

export type FileUploadedFooter_NotificationGroupTranscriptCompletedSelf_Fragment = { __typename?: 'NotificationGroupTranscriptCompletedSelf' };

export type FileUploadedFooter_NotificationGroupTransferBatchCompleted_Fragment = { __typename?: 'NotificationGroupTransferBatchCompleted' };

export type FileUploadedFooter_NotificationGroupTransferBatchCompletedSelf_Fragment = { __typename?: 'NotificationGroupTransferBatchCompletedSelf' };

export type FileUploadedFooter_NotificationGroupUserMentioned_Fragment = { __typename?: 'NotificationGroupUserMentioned' };

export type FileUploadedFooter_NotificationGroupUserMentionedShareAccess_Fragment = { __typename?: 'NotificationGroupUserMentionedShareAccess' };

export type FileUploadedFooterFragment = FileUploadedFooter_NotificationGroupAccessRequestApproved_Fragment | FileUploadedFooter_NotificationGroupAccessRequestDenied_Fragment | FileUploadedFooter_NotificationGroupAccessRequestSubmitted_Fragment | FileUploadedFooter_NotificationGroupAssetAssignedToYou_Fragment | FileUploadedFooter_NotificationGroupAssetStatusChanged_Fragment | FileUploadedFooter_NotificationGroupCommentCreated_Fragment | FileUploadedFooter_NotificationGroupCommentCreatedShareAccess_Fragment | FileUploadedFooter_NotificationGroupFileUploaded_Fragment | FileUploadedFooter_NotificationGroupReplyCreated_Fragment | FileUploadedFooter_NotificationGroupReplyCreatedShareAccess_Fragment | FileUploadedFooter_NotificationGroupRequesterAccessRequestApproved_Fragment | FileUploadedFooter_NotificationGroupRequesterAccessRequestDenied_Fragment | FileUploadedFooter_NotificationGroupTranscriptCompletedSelf_Fragment | FileUploadedFooter_NotificationGroupTransferBatchCompleted_Fragment | FileUploadedFooter_NotificationGroupTransferBatchCompletedSelf_Fragment | FileUploadedFooter_NotificationGroupUserMentioned_Fragment | FileUploadedFooter_NotificationGroupUserMentionedShareAccess_Fragment;

export const FileUploadedFooter = /*#__PURE__*/ gql`
    fragment FileUploadedFooter on NotificationGroup {
  ... on NotificationGroupFileUploaded {
    content {
      layout {
        ...FooterContent
      }
    }
  }
}
    ${FooterContent}` as unknown as DocumentNode<FileUploadedFooterFragment, unknown>;

        

        
export const useFileUploadedFooterFragment = (
  input: string | Omit<UseFragmentOptions<FileUploadedFooterFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'NotificationGroup' } };
    return input;
  })();

  return useFragment<FileUploadedFooterFragment>({
    fragment: FileUploadedFooter,
    fragmentName: 'FileUploadedFooter',
    ...options,
  });
};
  
        